import {makeStyles, Theme} from '@material-ui/core';
import {required} from 'ra-core';
import RichTextInput from 'ra-input-rich-text';
import React from 'react';
import {BooleanInput, Create, Edit, ImageField, ImageInput, ReferenceArrayInput, SelectArrayInput, SelectInput, SimpleForm, TextInput} from 'react-admin';
import {ARTICLE_SECTION, ARTICLE_STATES, COLUMN, COLUMN_CATEGORY, KEYWORDS} from '../../consts/Names';
import '../../fonts/fonts.css';
import ListActions from '../BaseListActions';
import {WithProps} from '../utils/RecordWrappers';
import {ColumnForm} from './ColumnForm';
import {ColumnCreateToolbar, ColumnEditToolbar} from './ColumnToolbars';
import {trimValidation} from '../../consts/Validators';
import {sanitize} from './sanitize';
const useStyles = makeStyles((theme: Theme) => ({
   formContainer: {
      padding: '0 1em 1em 1em'
   },
   category: {
      width: '300px',
      display: 'flex',
      marginTop: '1em'
   },
   toolBar: {
      flex: 1,
      display: 'flex',
      'justify-content': 'space-between'
   },
   textFld: {
      width: '100%'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   }
}));

const reWorkingRecord = (record) => {
   let newRecord = Object.assign({}, record);
   if (record.section) {
      newRecord.isHightlight = record.section === ARTICLE_SECTION.HIGHTLIGHT ? true : false;
   } else newRecord.isHightlight = false;
   if (record.keywords) {
      newRecord.keyword_ids = record.keywords.map((el) => el.id);
      // delete record.keywords;
   }
   return newRecord;
};

export const ColumnCreate = (props) => {
   const {theme} = props;
   const classes = useStyles(theme);
   const toolbarOptions = [
      [{size: []}],
      ['bold', 'underline', 'strike'],
      [{color: []}, {background: []}],
      [{script: 'super'}, {script: 'sub'}],
      [{header: '1'}, {header: '2'}, 'blockquote', 'code-block'],
      [{list: 'ordered'}, {list: 'bullet'}, {indent: '-1'}, {indent: '+1'}],
      ['direction', {align: []}],
      ['link', 'image', 'video'],
      ['clean']
   ];

   //    let Font = Quill.import('formats/font');
   // // We do not add Sans Serif since it is the default
   // Font.whitelist = ['inconsolata', 'roboto', 'mirza', 'arial'];
   // Quill.register(Font, true);

   // // We can now initialize Quill with something like this:
   // let quillObj = new Quill('#editor', {
   //    modules: {
   //      toolbar: '#toolbar-container'
   //    },
   //    placeholder: 'This is a font test...',
   //    theme: 'bubble'
   //  });
   // const SELECTOR_CONTAINER = '#quill-container-2';
   // const DEFAULT_CONFIG = {
   //         theme: 'bubble',
   //         bounds: SELECTOR_CONTAINER
   // };

   // let quill = new Quill(SELECTOR_CONTAINER, DEFAULT_CONFIG);
   //    let Font = Quill.import('formats/font');
   // // We do not add Sans Serif since it is the default
   // Font.whitelist = ['inconsolata', 'roboto', 'mirza', 'arial'];
   // Quill.register(Font, true);

   //  const configureQuill = quillObj => quillObj.getModule('toolbar').addHandler('bold', function (value) {

   // });
   // const quill = new Quill('article');
   // useEffect(() => {
   //    let elem = document.querySelector('.ql-font .ql-picker-label');
   //    if (elem) {
   //       let style = document.createElement('style');
   //       style.type = 'text/css';
   //       style.innerHTML =
   //          '.custom-label { cursor: pointer} .custom-item {cursor: pointer;\n' + '    display: block;\n' + '    padding-top: 5px;\n' + '    padding-bottom: 5px;}';
   //       document.getElementsByTagName('head')[0].appendChild(style);

   //       elem.classList.add('custom-label');
   //       elem.classList.remove('ql-picker-label');
   //       const proppps = document.querySelectorAll('.ql-picker-options');
   //       for (let i = 0; proppps[0].children.length > i; i++) {
   //          proppps[0].children[i].classList.add('custom-item');
   //          proppps[0].children[i].classList.remove('ql-picker-item');
   //       }
   //       const placeholderPickerItems = Array.prototype.slice.call(document.querySelectorAll('.ql-font .custom-item'));
   //       placeholderPickerItems.forEach((item) => (item.textContent = item.dataset.value));
   //       elem.innerHTML = 'Posts';
   //    }
   // }, []);

   // quill.getModule('toolbar').addHandler('link', function sanitizeLinkInput(linkValueInput) {
   //    console.log(linkValueInput)
   // const cursorPosition = quill.getSelection().index;
   // if(cursorPosition < 10){
   //    let myBounds = quill.getBounds(10, 0);
   //    // quill.theme.tooltip.position(myBounds)
   //    quill.theme.tooltip.show()
   // }
   // quill.theme.tooltip.show()
   // quill.theme.tooltip.focus()
   // }
   // );

   sanitize();
   return (
      <Create {...props} title="Create new article">
         <WithProps callBackFunc={reWorkingRecord}>
            {({record, ...props}) => (
               <SimpleForm {...props} record={record} toolbar={<ColumnCreateToolbar {...props} />} className={classes.formContainer} redirect="list">
                  {/*<TextInput className={classes.textFld} label="Title" source="title" validate={[required(), trimValidation]} />*/}
                  {/*<ReferenceArrayInput label="Category" source="category_ids" reference="categories" validate={[required()]}>*/}
                  {/*   <SelectArrayInput optionText="name" />*/}
                  {/*</ReferenceArrayInput>*/}
                  {/*<SelectInput label="State of publish" source={COLUMN.state} validate={[required()]} choices={ARTICLE_STATES}/>*/}
                  {/*<BooleanInput source="isHightlight" label="Highlighted"/>*/}
                  {/*<ImageInput*/}
                  {/*   className={classes.imageFld}*/}
                  {/*   source="images"*/}
                  {/*   label="Related pictures"*/}
                  {/*   accept="image/*"*/}
                  {/*   multiple={true}*/}
                  {/*   placeholder={<p>Drop your image here</p>}*/}
                  {/*   validate={[required()]}>*/}
                  {/*   <ImageField source={COLUMN_CATEGORY.image} />*/}
                  {/*</ImageInput>*/}
                  {/*<TextInput fullWidth={false} label="Image Alt Text" source="image_alt_text" validate={[required(), trimValidation]} />*/}
                  {/*<ReferenceArrayInput label="Keywords" source="keyword_ids" fullWidth reference={KEYWORDS.SOURCE} className={classes.category}>*/}
                  {/*   <SelectArrayInput optionText="name" />*/}
                  {/*</ReferenceArrayInput>*/}
                  {/*<TextInput fullWidth={true} label="Meta keywords" source="meta_keywords" validate={[required(), trimValidation]} />*/}
                  {/*<TextInput fullWidth={true} label="Meta Description" source="meta_description" validate={[required(), trimValidation]} />*/}
                  {/*<RichTextInput*/}
                  {/*   fullWidth={true}*/}
                  {/*   source="text"*/}
                  {/*   label="Article"*/}
                  {/*   toolbar={toolbarOptions}*/}
                  {/*   validate={[required(), trimValidation]}*/}
                  {/*   // configureQuill={configureQuill}*/}
                  {/*/>*/}
                  <ColumnForm {...props} classes={classes} />
               </SimpleForm>
            )}
         </WithProps>
      </Create>
   );
};

export const ColumnEdit = (props) => {
   const {theme, basePath} = props;
   const classes = useStyles(theme);
   sanitize();
   return (
      <Edit {...props} title="Edit existing article" actions={<ListActions basePath={basePath} />} undoable={false}>
         <WithProps callBackFunc={reWorkingRecord}>
            {({record, ...props}) => (
               <SimpleForm {...props} record={record} className={classes.formContainer} toolbar={<ColumnEditToolbar {...props} className={classes.toolBar} />}>
                  <ColumnForm {...props} classes={classes} />
               </SimpleForm>
            )}
         </WithProps>
      </Edit>
   );
};
